import { atom } from "recoil";
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist();

export const currentQuestionnaire = atom({
    key: 'currentQuestionnaire',
    default: {}
});

export const questionnaire = atom({
    key: 'questionnaire',
    default: [],
    effects_UNSTABLE: [persistAtom]
});

export const stores = atom({
    key: 'stores',
    default: [],
    effects_UNSTABLE: [persistAtom]
});

export const current = atom({
    key: 'current',
    default: ''
});

export const completed = atom({
    key: 'completed',
    default: 0
});
